<template>
  <div class="background-03">
    <v-layout row wrap text-xs-right>
      <v-flex xs12 sm9 class="animated fadeInUp dura_1">
        <ui-title-one titleAccess="¿Para qué sirve un presupuesto?" titleLevel="h1">
          <template slot="partOne">¿Para qué sirve un<br></template>
          <!-- <template slot="partTwo"></template> -->
          <template slot="partThree"> presupuesto?</template>
        </ui-title-one>
      </v-flex>
      <v-flex xs12 sm2 text-xs-right class="hidden-xs-only ">
        <image-app class="animated fadeInRight" :imaSize="250" imaSrc="design/banco1-1-3-2" imaAlt=""></image-app>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center">
        <ui-simple-lsc :vidTittle="'¿Para qué sirve un presupuesto?'" videoEmbed="ADMINISTRACIONDINERO18ParaQueSirvePresupuesto(49).mp4"></ui-simple-lsc>
      </v-flex>
      <v-flex xs12 sm5 md5 text-xs-center class="aligner animated fadeIn dura_2">
        <image-app class="animated fadeInLeft" :imaSize="450" imaSrc="contenido/diapositiva_19" imaAlt="Ejemplo de presupuesto familiar"></image-app>
      </v-flex>
      <v-flex xs12 md6 class="animated fadeInUp dura_2 aligner">
        <p class="text-box adorn-right">
          Un presupuesto
          <strong>clarifica</strong> los
          <strong>ingresos</strong> recibidos y los
          <strong>gastos</strong> generados en un periodo de tiempo, además ayuda a alcanzar
          <strong>metas</strong> y a reconocer la
          <strong>realidad financiera</strong>:
          <br><br>
          <ui-list bullet="bullet-dav" :lista="lista"></ui-list>
        </p>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      lista: [
        "¿Cuánto dinero entra? ",
        "¿Cuánto se gasta? ",
        "¿Cuánto se debe? ",
        "¿Cuánto se malgasta?"
      ]
    };
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-18.vue?c9c1f498